import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { DataService } from 'src/app/data.service';
import { StorefrontService } from 'src/app/storefront/storefront.service';
import { ParentalControlService } from '../services/evergent/parental-control/parental-control.service';
import { RoutingService } from '../services/routing.service';
import { LocalStorageService } from '../services/storage/local-storage.service';
import { TabService } from '../services/tabs/tab.service';
import { KEYS } from '../utils/constants/storage.constants';
import { AdaptorData } from 'src/app/storefront/AdaptorData';

@Injectable({
  providedIn: 'root',
})
export class PlayerGuard implements CanActivate {
  constructor(
    private readonly dataService: DataService,
    private readonly storefrontService: StorefrontService,
    private readonly parentalControlService: ParentalControlService,
    private readonly routingService: RoutingService,
    private readonly router: Router,
    private readonly tabService: TabService,
    private readonly localStorage: LocalStorageService
  ) {}

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    // We need the resource metadata to check parental status
    let resource = this.dataService.selectedCardData;
    if (resource) {
      return true;
    }

    if (!resource || this.dataService.isFromDeeplink) {
      const contentType = route.params.type;
      const id = route.params.id;

      const adaptorData: AdaptorData = {
        resourceType: contentType,
        resourceId: id,
        storefrontId: this.localStorage.getItem(KEYS.STOREFRONT_ID),
        tabId: this.dataService.activeTab,
        tabName: this.tabService.getCurrentTab()?.name,
      };

      try {
        resource = await this.storefrontService.fetchResourceDetails(
          adaptorData
        );
        this.dataService.selectedCardData = resource;
      } catch (e) {
        this.router.navigate([this.dataService.homeTab || '/']);
        return false;
      }
    }

    if (!resource) {
      return true; // Let resolver handle error or let it pass if no resource
    }

    // Parental Check
    const hasRating = resource.ratings?.length && resource.ratings[0];
    const canAccess =
      this.dataService.isParentalEnabled && hasRating
        ? await this.parentalControlService.checkParentalLevels(resource)
        : true;

    if (!canAccess) {
      // Stop CURRENT navigation
      this.routingService.navigateToPlayerWithValidation(
        {
          resource: resource,
          navigationPath: `player/${route.params.type}/${route.params.id}`,
        },
        () => {
          // On cancel, go to detail page
          this.router.navigate([route.params.type, route.params.id], {
            state: { resourcevm: resource },
          });
        }
      );

      return false; // Actually blocks the routing
    }

    return true;
  }
}
